function editStockCommandForm (id, provider, setCurrentId, openCommandForm, setOpenCommandForm, setCurrentProvider) {
    setCurrentId(id);
    setOpenCommandForm(!openCommandForm);
    setCurrentProvider(provider);
}

export default editStockCommandForm;